<script setup lang="ts">
definePageMeta({
    middleware: ['language-item-from-path'],
});

const route = useRoute();
</script>

<template>
    <Page>
        <PronounsDetailPage
            v-if="route.meta.pronoun"
            :pronoun="route.meta.pronoun"
            :show-sources="!Object.hasOwn(route.query, 'nosources')"
        />
        <NounsConventionPage
            v-else-if="route.meta.nounConvention"
            :noun-convention="route.meta.nounConvention"
        />
    </Page>
</template>
